<template>
    <modal ref="modal" dark>
      <div id="sub-wrapper">
        <div class="from">{{ message.from }}</div>
        <div class="message">{{ message.message }}</div>
      </div>
    </modal>
</template>

<script>
export default {
  data () {
    return {
      message: {
        from: '',
        message: ''
      },
      timeout: null
    }
  },
  methods: {
    show (message) {
      this.message = message
      this.$refs.modal.show()
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(function () {
        this.hide()
      }.bind(this), this.duration(message.message))
    },
    hide () {
      this.$refs.modal.hide()
    },
    duration (message) {
      // 3 base seconds to recover from suprise + 250 words per minute
      return 3000 + 60000 / 250 * message.split(' ').length
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 35em;
}

#sub-wrapper .from {
  font-size: 2em;
  margin-bottom: 1em;
}

#sub-wrapper .message {
  font-size: 1.5em;
}

</style>
